// 9fbef606107a605d69c0edbcd8029e5d 
import { TRACK_ORDER_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const TRACK_ORDER_CONSTANTS = {
  TRACK_ORDER: `${TRACK_ORDER_ACTION_PATTERN}TRACK_ORDER`,
  SET_TRACK_ORDER_MODAL_MOUNTED_STATE: `${TRACK_ORDER_ACTION_PATTERN}SET_TRACK_ORDER_MODAL_MOUNTED_STATE`,
  CLOSE_TRACK_ORDER_MODAL: `${TRACK_ORDER_ACTION_PATTERN}CLOSE_TRACK_ORDER_MODAL`,
  TRACK_ORDER_FORM_NAME: 'TrackOrderForm',
  SET_ORDER_DETAIL_INFO: `${TRACK_ORDER_ACTION_PATTERN}ORDER_DETAIL`,
  SET_ERROR_INFO: `${TRACK_ORDER_ACTION_PATTERN}SET_ERROR_INFO`,
  SET_ERROR_INFO_NULL: `${TRACK_ORDER_ACTION_PATTERN}SET_ERROR_INFO_NULL`,
  SET_ORDER_INITIATOR: `${TRACK_ORDER_ACTION_PATTERN}SET_ORDER_INITIATOR`,
};

export default TRACK_ORDER_CONSTANTS;
